module.exports = __webpack_public_path__ + "media/img/why-vendor/03-6a6cc110c2e6d08097842d601af1827b.png";